const CLEAR_PROPOSED_DISCUSSION = (state) => {
  state.proposedDiscussion = {};
};

export default CLEAR_PROPOSED_DISCUSSION;
